export default __webpack_public_path__ + "static/media/Upasna.c47af423.mp3";